import StorySearchSelect from './StorySearchSelect';

export default StorySearchSelect;
